module.exports = __webpack_public_path__ + "img/provider-apply.6f9ca480.svg";